module.exports = __webpack_public_path__ + "static/image_2-60e2365975d6140062a7a45643b15382.jpg";